import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Bell, CheckCheck, AlarmClockOff } from "lucide-react";

export default function NotificationsBell() {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);

  const { data: count } = useQuery({
    queryKey: ["notif-count"],
    queryFn: async () => (await api.get("/notifications/unread-count")).data.count,
    refetchInterval: 60000,
  });
  const { data: items = [] } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => (await api.get("/notifications")).data,
    enabled: open,
  });

  const readAll = useMutation({
    mutationFn: async () => (await api.put("/notifications/read-all")).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notifications"] });
      qc.invalidateQueries({ queryKey: ["notif-count"] });
    },
  });

  return (
    <div className="relative">
      <button data-testid="notifications-bell" onClick={() => setOpen(!open)}
        className="relative h-9 w-9 rounded-full border border-[#E3DED4] bg-white flex items-center justify-center hover:border-[#B9AE9A]">
        <Bell className="h-4 w-4 text-[#45423C]" />
        {count > 0 && (
          <span data-testid="notifications-count" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] rounded-full bg-[#991B1B] text-white text-[10px] font-bold flex items-center justify-center px-1">
            {count}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div data-testid="notifications-panel" className="absolute right-0 mt-2 w-[340px] max-h-[420px] overflow-y-auto rounded-2xl bg-white border border-[#E3DED4] shadow-lg z-50">
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#E3DED4]">
              <span className="text-sm font-semibold text-[#45423C]">Ειδοποιήσεις</span>
              <button data-testid="notifications-read-all" onClick={() => readAll.mutate()} className="inline-flex items-center gap-1 text-xs text-[#6F6A60] hover:text-[#45423C]">
                <CheckCheck className="h-3.5 w-3.5" /> Όλα ως διαβασμένα
              </button>
            </div>
            {items.length === 0 ? (
              <div className="px-4 py-8 text-center text-sm text-[#6F6A60]">Καμία ειδοποίηση</div>
            ) : items.map((n) => (
              <div key={n.id} data-testid={`notification-${n.id}`} className={`px-4 py-3 border-b border-[#E3DED4] last:border-0 ${n.read ? "" : "bg-[#FFFBEB]"}`}>
                <div className="flex items-start gap-2">
                  <AlarmClockOff className="h-4 w-4 mt-0.5 text-[#C86235] shrink-0" />
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-[#45423C]">{n.title}</div>
                    <div className="text-xs text-[#6F6A60] mt-0.5">{n.message}</div>
                    <div className="text-[10px] text-[#6F6A60] mt-1">{fmtDateTime(n.created_at)}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
